import type { User } from '../types/user';
import { hasRole, hasBridgeAccess } from '../utils/permissions';

export interface PlanningNavItem {
  key: string;
  label: string;
  path: string;
  roleKey: string;
  icon: string;
}

/** Canonical Budget Planning nav order (MVP-enabled items). */
export const PLANNING_NAV_ITEMS: PlanningNavItem[] = [
  { key: 'io-plans', label: 'IO Plans', path: '/planning/io-plans', roleKey: 'feature.io_plans', icon: 'folder' },
  { key: 'io-requests', label: 'IO Requests', path: '/planning/io-requests', roleKey: 'feature.io_requests', icon: 'clipboard-check' },
  // DISABLED: MEC (see docs/DISABLED_FEATURES.md)
  // { key: 'mec', label: 'MEC', path: '/planning/mec', roleKey: 'feature.mec', icon: 'calendar-check' },
  // DISABLED: Pull Forwards (see docs/DISABLED_FEATURES.md #17)
  // { key: 'pull-forwards', label: 'Pull Forwards', path: '/planning/pull-forwards', roleKey: 'feature.pull_forwards', icon: 'arrow-left-right' },
  { key: 'recharges', label: 'Recharges', path: '/planning/recharges', roleKey: 'feature.recharges', icon: 'users' },
  { key: 'bridges', label: 'Bridges', path: '/planning/bridges', roleKey: 'feature.bridges', icon: 'git-compare' },
  { key: 'one-pagers', label: 'One Pagers', path: '/planning/one-pagers', roleKey: 'feature.one_pagers', icon: 'file-text' },
  // DISABLED: T&E, Preso, Travel (see docs/DISABLED_FEATURES.md)
];

export function isPlanningNavItemVisible(user: User | null, item: PlanningNavItem): boolean {
  if (!hasRole(user, item.roleKey)) return false;
  if (item.key === 'bridges' && !hasBridgeAccess(user)) return false;
  return true;
}

export function getVisiblePlanningNavItems(user: User | null): PlanningNavItem[] {
  return PLANNING_NAV_ITEMS.filter((item) => isPlanningNavItemVisible(user, item));
}

/** Primary entry when clicking Budget Planning in top nav (IO Plans with role fallback). */
export function getPlanningSectionHomePath(user: User | null): string {
  const visible = getVisiblePlanningNavItems(user);
  const ioPlans = visible.find((item) => item.key === 'io-plans');
  if (ioPlans) return ioPlans.path;
  return visible[0]?.path ?? '/planning';
}
